<router-outlet></router-outlet>
<!-- Spinner overlay en dernier -->
@if (loading()) {
  <div
    class="fixed left-0 right-0 top-0 bottom-0 z-9999 flex items-center justify-center bg-green-100 opacity-70"
  >
    <mat-progress-spinner class="example-margin" [mode]="'indeterminate'" value="50">
    </mat-progress-spinner>
  </div>
}
